import { GenisLogo } from "@/components/GenisLogo";

export const BrandLogo = ({ partner }) => {
  if (!partner?.logo_url) return <GenisLogo size="md" />;
  return (
    <div className="flex items-center gap-3 h-10" data-testid="partner-logo">
      <img src={partner.logo_url} alt={partner.name} className="h-14 w-auto object-contain dark:h-11 dark:bg-white dark:rounded-lg dark:px-2 dark:py-1" data-testid="partner-logo-img" />
      <span className="hidden sm:block text-[10px] text-muted-foreground border-l border-border pl-3">avec Genis Energie</span>
    </div>
  );
};
